var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M2.052 9.535h1.872-.01c.253-.01.468.21.468.47V14.8c0 .528.412.95.936.95H6.72l-.01-.001a.95.95 0 0 0 .936-.96v-2.397a.476.476 0 0 1 .459-.49h1.87-.008c.252-.009.467.212.467.47v2.399c0 .527.412.95.936.95h1.403l-.009-.002a.95.95 0 0 0 .936-.959V9.964a.47.47 0 0 1 .458-.489h1.871c.253 0 .468-.22.468-.48a.52.52 0 0 0-.159-.364L9.631 2.504l-.01-.01a.914.914 0 0 0-1.244 0l-6.708 6.11h-.01a.48.48 0 0 0-.046.672.47.47 0 0 0 .346.153z"
})));
export default SvgHome;